import { getProductsUrl } from '../../helpers/getStoreUrl';
import { fieldI18nLanguage } from '../../helpers/i18n';
import createSlug from '../../helpers/createSlug';

import { createChangeLogSection } from '../../components/FieldChangeLog';

export const fieldName = ['FieldText', {
  name: 'name',
  rules: [['validation.isRequired']],
  i18nTranslatable: true,
  prepareValueForForm: (value, props) => {
    if (props.activity === 'create') {
      let i18nLanguageValue = null;
      const form = (
          props.forms
        ? props.forms[props.forms.length - 1]
        : props.form
      );
      if (form && form.getFieldValue) {
        i18nLanguageValue = form.getFieldValue('i18nLanguage') || 'en';
      } else {
        i18nLanguageValue = 'en';
      }
      if (i18nLanguageValue === 'en') {
        props.form.setFieldsValue({ slug: createSlug(value?.target?.value) });
      }
    }
    return value;
  },
}];

export const fieldStoreDivider = ['Divider', {
  name: 'storeDivider',
}];

export const fieldStore = ['FieldConnectionSelect', {
  name: 'store',
  placeholder: 'Select the collection store',
  url: '/stores/list',
  // getChoiceLabel: choice => choice.data.name,
  searchPaths: ['name'],
  rules: [['validation.isRequired']],
  disabled: [props => props.activity !== 'create'],
  virtual: [props => props.activity !== 'create'],
}];

export const fieldSlug = ['FieldSlug', {
  name: 'slug',
  rules: [['validation.isRequired']],
  copyLinkValue: value => `?collection=${value}`,
  copyLinkSegments: [
    (props) => {
      if (props.data && props.data.storeData) {
        return getProductsUrl(props.data.storeData);
      }
      return null;
    },
  ],
  addonBefore: '?collection=',
}];

export const ADMIN = [
  fieldI18nLanguage,
  fieldName,
  fieldSlug,
  fieldStoreDivider,
  fieldStore,
  ...createChangeLogSection({
    changeLogConfig: {
      getWhereConditions: props => ({
        store: props.data?.store,
        'target.type': 'Collection',
        'target.subject': props.data._id,
      }),
      skipColumns: {
        store: true,
        realm: true,
        target: true,
      },
    },
  }),
];

export const SELLER = [
  fieldI18nLanguage,
  fieldName,
  fieldSlug,
];
